import { Inject, Injectable } from '@angular/core';
import { IUnitOfWork } from '@common/contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { ServiceDto } from 'src/app/shared/models/service-entity/service-dto.model';

import { ServiceDB } from '../../common/repository/databases';
import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class ServiceWorkItem extends WorkItem<ServiceDto> {
  unitOfWork: IUnitOfWork;
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
    this._deletable = false;
  }

  get name(): string {
    return 'ServiceWorkItem';
  }
  get database(): string {
    return ServiceDB;
  }
}
